import { Editor, Element, Node, Path, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import * as serializer from 'basic-editor-value-serializer';
import { hostsBlocks, isEmptyParagraph } from '../layout/insert';
import { countLayoutAncestors, insertAfterBlock, isInRow, moveItemSettings } from '../layout/wrap';

export function canInsertAt(editor, path) {
  if (path === null || Node.has(editor, path) === false) {
    return false;
  }
  if (Element.isElement(Node.get(editor, path)) === false || hostsBlocks(editor, path) === false) {
    return false;
  }
  return isInRow(editor, path) === false || countLayoutAncestors(editor, path) < serializer.utilities.node.layout.MAX_DEPTH;
}

export function insert(editor, path) {
  if (canInsertAt(editor, path) === false) {
    return null;
  }
  let inserted = null;
  HistoryEditor.withNewBatch(editor, function insertIcon() {
    Editor.withoutNormalizing(editor, function placeIcon() {
      const node = serializer.utilities.node.icon.buildNode();
      if (isEmptyParagraph(editor, Node.get(editor, path)) === true) {
        Transforms.insertNodes(editor, node, { at: path });
        moveItemSettings(editor, Path.next(path), path);
        Transforms.removeNodes(editor, { at: Path.next(path) });
        inserted = path;
      } else {
        inserted = insertAfterBlock(editor, path, [node]);
      }
      if (inserted !== null) {
        Transforms.select(editor, Editor.start(editor, inserted));
      }
    });
  });
  return inserted;
}
